import { PanelType, PivotItem } from "@fluentui/react";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import CustomPanel from "../../SharedComponents/CustomPanel/CustomPanel";
import { TabsContainer } from "../../SharedComponents/TabsContainer";
import { logEvent, logException } from "../../helper/AppInsightsHelper";
import { IPartnerContactsPanelProps } from "../../interfaces/PartnerView.interfaces";
import { ISelectedKey } from "../../SharedComponents/Interfaces/CustomContact.interfaces";
import { useGetPartnerContactListQuery } from "../../slices/ExplorePartners.slice";
import { CustomContactList } from "../../SharedComponents/CustomContactList";

const PartnerContactsPanel = ({ isOpen, onDismiss, partnerOneName }: IPartnerContactsPanelProps) => {
  const [selectedKey, setSelectedKey] = useState<ISelectedKey["selectedKey"]>("partnerContacts");
  const [params] = useSearchParams();
  const partnerOneID = params.get("partnerOneId");
  const mpnID = params.get("mpnId");
  const { data, error, isLoading, isSuccess } = useGetPartnerContactListQuery({
    partnerOneID: partnerOneID || "",
    mpnID: mpnID || ""
  });

  useEffect(() => {
    if (isSuccess && data) {
      logEvent("useGetPartnerContactListQuery API success", "PartnerContactsPanel", "PartnerContactList");
    }
    if (error) {
      logException("PartnerContactsPanel", "PartnerContactList", "useGetPartnerContactListQuery", error);
    }
  }, [data, error, isSuccess]);

  const onLinkClick = useCallback((item?: PivotItem) => {
    if (item?.props.itemKey) {
      setSelectedKey(item.props.itemKey as ISelectedKey["selectedKey"]);
    }
  }, []);

  return (
    <CustomPanel
      enablePanel={isOpen}
      dismissPanel={onDismiss}
      panelTitle={`Contacts for ${partnerOneName ?? "Partner"}`}
      panelType={PanelType.custom}
      isLoading={false}
      customWidth="500px"
    >
      <TabsContainer selectedKey={selectedKey} ariaLabel="Contacts tabs" handleSelectedTab={onLinkClick}>
        <PivotItem headerText="PDM Contacts" itemKey="partnerContacts" />
        <PivotItem headerText="General Contacts" itemKey="generalContacts" />
      </TabsContainer>
      {data?.cxeContacts?.length && selectedKey === "generalContacts" ? (
        <div
          style={{
            backgroundColor: "#FFF4CE",
            padding: "12px 16px",
            marginTop: "12px",
            borderRadius: "4px",
            fontSize: "14px",
            color: "#333333"
          }}
        >
          Only Microsoft contacts are shown
        </div>
      ) : null}
      <div style={{ marginTop: 20 }}>
        <CustomContactList
          selectedKey={selectedKey}
          contactData={{
            data: selectedKey === "partnerContacts" ? data?.partnerContacts || [] : data?.cxeContacts || [],
            error,
            isLoading,
            isSuccess
          }}
        />
      </div>
    </CustomPanel>
  );
};

export default PartnerContactsPanel;
